import React, { useMemo } from 'react';
import { Pane } from '@leverege/ui-elements';
import { Attributes } from '@leverege/ui-attributes';
import S from './CardStyle.css';
import Detail from './Detail';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function VehicleInfoCard(props) {
  const {
    vehicle
  } = props;
  const vehicleData = useMemo(() => ({
    vin: Attributes.get('vehicle.vin', 'vehicle', vehicle?.data) || '',
    year: Attributes.get('vehicle.year', 'vehicle', vehicle?.data) || '',
    make: Attributes.get('vehicle.make', 'vehicle', vehicle?.data) || '',
    model: Attributes.get('vehicle.model', 'vehicle', vehicle?.data) || '',
    stockNumber: Attributes.get('vehicle.stocknumber', 'vehicle', vehicle?.data) || ''
  }), [vehicle]);
  return /*#__PURE__*/_jsx(Pane, {
    variant: "dashboardCard",
    className: S.container,
    children: /*#__PURE__*/_jsxs(Pane, {
      layout: "flex:rowXXL",
      variant: "dataCard",
      children: [/*#__PURE__*/_jsxs(Pane, {
        layout: "flex:colL",
        children: [/*#__PURE__*/_jsx(Detail, {
          label: "VIN",
          value: vehicleData?.vin,
          type: "column"
        }), /*#__PURE__*/_jsx(Detail, {
          label: "Make",
          value: `${vehicleData?.year} ${vehicleData?.make} ${vehicleData?.model}`,
          type: "column"
        })]
      }), /*#__PURE__*/_jsx(Pane, {
        layout: "flex:colL",
        children: /*#__PURE__*/_jsx(Detail, {
          label: "Stock Number",
          value: vehicleData?.stockNumber,
          type: "column"
        })
      })]
    })
  });
}